import React, { Suspense } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import configureStore from "./redux/store";
import Setup from "./components/Setup";

////// import i18n (needs to be bundled ;))
import "./i18n";

const container = document.getElementById("root");
const root = createRoot(container);

const loading = (
  <div>
    <p></p>
  </div>
);

////// replace console.* for disable log in production
if (process.env.NODE_ENV === "production") {
  console.log = () => {};
  console.info = () => {};
  console.error = () => {};
  console.debug = () => {};
}

root.render(
  <Suspense fallback={loading}>
    <React.StrictMode>
      <Provider store={configureStore}>
        <Setup />
        <App />
      </Provider>
    </React.StrictMode>
  </Suspense>
);

reportWebVitals();
